
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import {baseUrl, labourType, limit, productType} from "../../../comman/config";
import Loader from "../../../comman/Loader";
import { PencilIcon, XCircleIcon } from '@heroicons/react/outline';
import {DateFilter} from "../../../comman/DateFilter.js";
import { useNavigate, Link } from 'react-router-dom';
import Pagination from "react-js-pagination";

function List() {

    const [debitList, setDebitList] = useState([]);
    const [staffList, setStaffList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    const [popupOpen, setPopupOpen] = useState(false);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [name, setName] = useState('');

    const [dueSalaryList, setDueSalaryList] = useState([]);
    const [duePage, setDuePage] = useState(1);
    const [dueTotalItem, setDueTotalItem] = useState(0);

    const navigate = useNavigate();

    useEffect(() => {
        getStaffList();
    }, []);
    useEffect(() => {
        getShopSalary();
        
    }, [page, fromDate,toDate, name]);

    useEffect(() => {
        getShopDueSalary();
        
    }, [duePage, fromDate,toDate, name]);

    const getStaffList = async (e) => {
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/admin/profile/labour/list`);
        setStaffList(response.data.data);
        setPopupOpen(false);
    }

    const handlePageChange  = (pageNumber) => {
        setPage(pageNumber);
    }
    const handleDuePageChange = (pageNumber) => {
        setDuePage(pageNumber);
    }

    const getShopSalary = async () => {
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/admin/account/list?page=${page}&limit=${limit}&fromDate=${fromDate}&toDate=${toDate}&name=${name}`);
        setPopupOpen(false);
        setDebitList(response.data.data);
        setTotalItem(response.data.totalItem);
    }

    const getShopDueSalary = async () => {
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/admin/farm/labour/due_list?page=${duePage}&limit=${limit}&fromDate=${fromDate}&toDate=${toDate}&name=${name}`);
        setPopupOpen(false);
        setDueSalaryList(response.data.data);
        setDueTotalItem(response.data.totalItem);
    }

    const deleteSalary = async (id) => {
        try {
            await axios.delete(`${baseUrl}/admin/farm/labour/delete/${id}`);
            window.location.reload();
        } catch (error) {
            console.log(error);
        }

    };

    const getStaffName = (item) => {
        return staffList.find((val) => val.id == item)?.name ?? "-";
    }

    const editSalary = async (id) => {
        navigate(`/admin/farm/labour/edit/${btoa(id)}`, { state: debitList.filter(item => item.id == id) });
    }

    const handelFilterChange= (fromDate, toDate, clear, today, name) => {
        setFromDate(fromDate);
        setToDate(toDate);  
        setName(name);
    };

    const getType = (name) => {
        return productType.find((item) => item.value == name)?.label ?? "-";
    }
    const getCategory = (name) => {
        return labourType.find((item) => item.value == name)?.label ?? "-";
    }

    return (
        
        <div className="p-4">
            {popupOpen && (
                     <Loader /> 
                ) }
            <div className="flex justify-between items-center py-4 px-6">
                <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">Credit / Debit</h1>
                <div>
                    <Link to="/admin/account/add">
                        <button className="px-4 py-2 bg-blue-900 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Add Due</button>
                    </Link>
                </div>
            </div>
            
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <DateFilter 
                handleFilterChange={handelFilterChange} 
            />
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                        <th scope="col" className="px-6 py-3 border">Date</th>
                        <th scope="col" className="px-6 py-3 border">Category</th>
                        <th scope="col" className="px-6 py-3 border">Type</th>
                        <th scope="col" className="px-6 py-3 border">Company Name</th>
                        
                        <th scope="col" className="px-6 py-3 border">Total Amount</th>
                        <th scope="col" className="px-6 py-3 border">Installment Amount</th>
                        <th scope="col" className="px-6 py-3 border">Remaining Amount</th>
                        {/* <th scope="col" className="px-6 py-3 border">Action</th> */}
                        </tr>
                       
                    </thead>
                    <tbody>
                    {debitList.map((item) => (
                        <tr key={item.id} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                            <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{item.date}</th>
                            <td className="px-6 py-4">{getCategory(item.category)}</td>
                            <td className="px-6 py-4">{getType(item.type)}</td>
                            <td className="px-6 py-4">{item.company_name}</td>
                            <td className="px-6 py-4">{item.total_amount}</td> 
                            <td className="px-6 py-4">{item.installment_amount}</td>
                            <td className="px-6 py-4">{item.due_amount}</td> 
                           
                            {/* <td className="px-6 py-4 flex">
                                    <a 
                                    onClick={() => editSalary(item.id)}
                                    className="font-medium text-blue-600 dark:text-blue-500 hover:underline mr-2">
                                        <PencilIcon className="w-4 h-4 inline-block" />
                                    </a>
                                    <a href="#" onClick={() => deleteSalary(item.id)} className="font-medium text-red-600 dark:text-red-500 hover:underline">
                                        <XCircleIcon className="w-4 h-4 inline-block" /> 
                                    </a>
                                </td> */}
                        </tr>))}
           
                    </tbody>
                </table>
            </div>
            {totalItem > limit && (<Pagination
              activePage={page}
              itemsCountPerPage={limit}
              totalItemsCount={totalItem}
              pageRangeDisplayed={5}
              onChange={handlePageChange.bind(this)}
            />)}
            <div>
            
          
            </div>
        </div>
        
  );
}

export default List;